import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  desktopHeader,
  mobileHeader,
} from 'site-modules/shared/components/clipped-container/mask-library/dealership-header';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';
import { DealerPhotosCarouselUI } from 'site-modules/dealerships/components/dealer-photos-carousel/dealer-photos-carousel';
import { DealerInfoEntities } from 'client/data/models/dealer-info';

import './dealer-header.scss';

export function DealerHeaderUI({ dealerInfo = {}, isMobile = false }) {
  return (
    <div className="dealer-header pos-r">
      <ClippedContainer
        containerClasses="top-eve-header pos-a top-0 left-0 right-0 w-100"
        mask={isMobile ? mobileHeader : desktopHeader}
      >
        <DealerPhotosCarouselUI dealerInfo={dealerInfo} />
      </ClippedContainer>
    </div>
  );
}

DealerHeaderUI.propTypes = {
  dealerInfo: DealerInfoEntities.DealerInfo,
  isMobile: PropTypes.bool,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const DealerHeader = connect(mapStateToProps)(DealerHeaderUI);
